'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiComponents = require('@wh/ui-components');

var _constants = require('./../constants');

require('./input-password.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Password input component
 * @returns {Element} React element
 */
var InputPassword = function (_React$Component) {
    (0, _inherits3.default)(InputPassword, _React$Component);

    function InputPassword(props, context) {
        (0, _classCallCheck3.default)(this, InputPassword);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InputPassword.__proto__ || (0, _getPrototypeOf2.default)(InputPassword)).call(this, props, context));

        _this.togglePasswordVisibility = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                type: _this.state.type === 'password' ? 'text' : 'password'
            });
            _this.props.trackingEvent(_constants.TRACKING_EVENT_NAME_FORM_INTERACT, {
                formFieldName: 'togglePasswordClicked'
            });
        };

        _this.state = {
            type: 'password'
        };
        return _this;
    }

    /**
     * Toggles password input type password/text
     * @param {event} e Event
     * @returns {void}
     */


    (0, _createClass3.default)(InputPassword, [{
        key: 'render',
        value: function render() {
            var type = this.state.type;
            var language = this.props.language;

            var iconClassNames = (0, _classnames2.default)({
                'svg-icon': true,
                'svg-icon-eye': type === 'password',
                'svg-icon-eye-slash': type !== 'password',
                'c-login-form__svg-toggle-password': true
            });

            var showPassword = language === 'en' ? (0, _jsx3.default)('span', {
                className: 'c-login-form__toggle-password',
                onClick: this.togglePasswordVisibility
            }, void 0, type === 'password' ? 'Show' : 'Hide') : (0, _jsx3.default)('i', {
                className: iconClassNames,
                onClick: this.togglePasswordVisibility
            });

            return (0, _jsx3.default)('div', {
                className: 'c-login-form__input-group--password-wrapper'
            }, void 0, _react2.default.createElement(_uiComponents.Input, (0, _extends3.default)({}, this.props, { type: type })), showPassword);
        }
    }]);
    return InputPassword;
}(_react2.default.Component);

exports.default = InputPassword;
//# sourceMappingURL=input-password.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/input-password/input-password.js
// module id = 484
// module chunks = 0